import {Stop} from './stop.model';

export class RouteShape {
  providerId: string;
  routeId: string;
  stops: Stop[];
  shape: string[];

  constructor() {
  }

  deserialize(input: any) {
    (<any>Object).assign(this, input);
    this.stops = input.stops.map((item) => new Stop().deserialize(item));
    this.shape = input.shape.map((item) => item);
    return this;
  }

}
